var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-tag',{attrs:{"type":_vm.computedStatus.type}},[_vm._v(_vm._s(_vm.computedStatus.label))])
}
var staticRenderFns = []

export { render, staticRenderFns }